import styled, { css } from "styled-components"

import { breakpoint } from "src/constants/breakpoints"
import { spacing } from "src/ui/spacing"

export const mainContentPadding = css`
  padding: ${spacing.M};
  @media (${breakpoint.mediumUp}) {
    padding: ${spacing.L} ${spacing.L} ${spacing.L} ${spacing.XL3};
  }
`

export const ProfileInfo = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: ${spacing.S};
  align-items: center;
  width: 100%;
  text-align: left;
`

export const ProfileInfoCenter = styled.div`
  line-height: 1.4;
  overflow: hidden;
`

export const ProfileInfoCenterTitle = styled.div`
  display: inline-grid;
  grid-template-columns: auto auto;
  align-items: center;
  gap: ${spacing.XS};
  margin-right: ${spacing.XS};
`

const ListItem = styled.div`
  padding-inline: ${spacing.M};
  padding-block: ${spacing.S};
`

export const ProfileListItem = styled(ListItem)`
  display: flex;
  align-items: center;
  gap: ${spacing.XS};
`

export const ellipsis = css`
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const Fullname = styled.div`
  ${ellipsis};
`
